export const webTracker = () => new window.Tracker(
    'cn-beijing.log.aliyuncs.com',
    'zeta',
    'frontend-pc-store',
    'zeta_pc-frontend'
);

export const webTrackerEvent = () => new window.Tracker(
    'cn-beijing.log.aliyuncs.com',
    'zeta',
    'frontend-pc-store',
    'zeta_pc-tracking'
);


// WEBPACK FOOTER //
// ./src/utils/tracker.js